export default __webpack_public_path__ + "static/media/bg-halopagi-2.ee144e51.png";